<template>
  <ProductCard v-if="product" :product="product" :media="videoObject" />
</template>

<script>
import ProductCard from "@/components/ProductCard.vue";
import productQuery from "@/graphql/queries/Product.gql";

export default {
  name: "AddFromVideo",
  components: {
    ProductCard,
  },
  props: {
    productHandle: {
      type: String,
      required: true,
    },
    videoUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      product: null,
    };
  },
  computed: {
    videoObject() {
      return {
        sources: [
          {
            url: this.videoUrl,
          },
        ],
      };
    },
  },
  apollo: {
    product: {
      query: productQuery,
      variables() {
        return {
          product: this.productHandle,
          selectedOptions: [],
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.info__left) {
  padding: 0 5px;
}
</style>
